// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// Importa (o lazy load) las vistas que ya tienes:
import LoginDisplay from '@/components/LoginDisplay.vue'
import UserPerfilator from '@/components/UserPerfilator.vue'
import CuponesHome from '@/components/CuponesHome.vue'
import CuponesParaTi from '@/components/CuponesParaTi.vue'
import DescuentosView from '@/components/DescuentosView.vue'
import CategoriaSeleccion from '@/components/CategoriaSeleccion.vue'
import CategoriaDetalle from '@/components/CategoriaDetalle.vue'
import FlashmaniaView from '@/components/FlashmaniaView.vue'
import HistorialView from '@/components/HistorialView.vue'
import CercaView from '@/components/CercaView.vue'
import SeccionBuscador from '@/components/SeccionBuscador.vue'

const routes = [
  // Página inicial (antes: view == '' o false)
  { path: '/', name: 'root', component: LoginDisplay },

  // Mapea 1:1 tus “views” actuales a rutas limpias:
  { path: '/perfilator', name: 'perfilator', component: UserPerfilator },
  { path: '/perfilador', name: 'perfilador', component: UserPerfilator },

  // Home / inicio
  { path: '/home', name: 'home', component: CuponesHome },
  { path: '/inicio', name: 'inicio', component: CuponesHome },

  // Rutas restantes
  { path: '/cupon', name: 'cupon', component: CuponesParaTi },
  { path: '/descuentos', name: 'descuentos', component: DescuentosView },
  { path: '/categorias', name: 'categorias', component: CategoriaSeleccion },
  { path: '/categoriadetalle', name: 'categoriadetalle', component: CategoriaDetalle },
  { path: '/flashmania', name: 'flashmania', component: FlashmaniaView },
  { path: '/historial', name: 'historial', component: HistorialView },
  { path: '/cerca', name: 'cerca', component: CercaView },
  { path: '/search', name: 'search', component: SeccionBuscador },

  // 404 básico
  { path: '/:pathMatch(.*)*', name: 'not-found', component: LoginDisplay },
]

const router = createRouter({
  // Si tu app vive bajo un subpath en Laravel, cambia el base:
  // createWebHistory('/mi-subcarpeta')
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
  scrollBehavior() { return { top: 0 } }
})

export default router
